import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=1630d93a&"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts&"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports